import ComicsList from '../comicsList/ComicsList';
import AppBanner from '../appBanner/AppBanner';


const ComicsPage = () => (
    <>
        <AppBanner />
        <ComicsList />
    </>
);

export default ComicsPage;
